import { environment } from "../../../environments/environment";
import { ApiService } from "./api.service";
import { localStorageService } from "./localstorage.service";
import { Injectable, signal } from "@angular/core";
import { BehaviorSubject, combineLatest, distinctUntilChanged, Observable, Subject } from "rxjs";
import { Router } from "@angular/router";
import { SocketsService } from "./socket/socket.service";

@Injectable({
  providedIn: 'root'
})
export class MainService {

  private normalizeAdminArray(value: any): number[] {
    if (!value) {
      return [];
    }

    if (Array.isArray(value)) {
      return value.map((id: any) => Number(id)).filter((id: number) => !Number.isNaN(id));
    }

    if (typeof value === 'string') {
      const cleaned = value.replace(/^\[|\]$/g, '').trim();
      if (!cleaned) {
        return [];
      }

      return cleaned
        .split(',')
        .map((id: string) => Number(id.trim()))
        .filter((id: number) => !Number.isNaN(id));
    }

    return [];
  }

  settlement_new_card_metadata: any;
  public env = environment;
  noteadded = false;

  // public timezone$: BehaviorSubject<any> = new BehaviorSubject('-700');

  // public timezoneName$: BehaviorSubject<any> = new BehaviorSubject('');

  // public zone$: BehaviorSubject<any> = new BehaviorSubject('');

  public timezoneList$: BehaviorSubject<any> = new BehaviorSubject([]);

  public global_admin_list$: BehaviorSubject<any> = new BehaviorSubject([]);

  public currency_data$: BehaviorSubject<any>  = new BehaviorSubject([]);

  public country_data$: BehaviorSubject<any>  = new BehaviorSubject([]);

  public selected_country$: BehaviorSubject<any>  = new BehaviorSubject([]);

  public currencySymbol$: BehaviorSubject<string> = new BehaviorSubject<string>('$');

  public mobile_code_arr$: BehaviorSubject<any>  = new BehaviorSubject([]);

  public language_data$: BehaviorSubject<any>  = new BehaviorSubject([]);

  public salutations$: BehaviorSubject<any>  = new BehaviorSubject([]);

  public government_docs$: BehaviorSubject<any>  = new BehaviorSubject([]);

  public menu$: BehaviorSubject<any>  = new BehaviorSubject([]);

  public admin_array = signal<number[]>([]);

  public denefits_slot$: BehaviorSubject<any>  = new BehaviorSubject(0);
  public dispute_docs_allowed_admins$: BehaviorSubject<any>  = new BehaviorSubject(0);
  
  public industryList$: BehaviorSubject<any>  = new BehaviorSubject([]);

  public stripeKey$: BehaviorSubject<any>  = new BehaviorSubject('');

  public credee_slot$: BehaviorSubject<any>  = new BehaviorSubject(0);

  show_all_assignments_roles: Number[] = [1, 4, 7, 9, 13];
  toaster: any;
  stripe: any;
  stripe_element: any;
  global_bar: boolean = true;
  active_for_chat: any;
  role: any;
  admin_twilio_list: any;
  // mask$: BehaviorSubject<any>  = new BehaviorSubject('');
  constructor(private _api: ApiService, private _local: localStorageService, private _router: Router,private _socket : SocketsService) {
    this.init();
  }

  init() {
    this._api.api({}, 'auth/get_settings', 'get')
      .subscribe((response: any) => {
        if (!response.is_error) {
          const currencies = response.currency_data || [];
          const countryData = (response.country_data || []).map((country: any) => {
            const currency = currencies.find((item: any) =>
              (country.currency_id != null && String(item.currency_id) === String(country.currency_id)) ||
              (country.country_id != null && String(item.country_id) === String(country.country_id))
            );
            return {
              ...country,
              cocu_id: country.cocu_id ?? currency?.cocu_id ?? null,
            };
          });
          this.country_data$.next(countryData);
          if (currencies.length) {
            this.currency_data$.next(currencies);
          }
          this.salutations$.next(response.salutation);
          this.mobile_code_arr$.next(response.mobile_code_arr && response.mobile_code_arr[0] ? response.mobile_code_arr : ['+1']);
          this.language_data$.next(response.language_data);
          this.denefits_slot$.next(response.denefits_slots);
          this.credee_slot$.next(response.credee_slots);
          this.dispute_docs_allowed_admins$.next(response.dispute_docs_allowed_admins);

          // static check
          const timezones = response.timezones ? response.timezones.filter((item: any) => item.country_id === 1) : [];
          timezones.splice(0,0,{
            "offset": "IST",
            "val": "+530",
            "name": "Indian Standard Time",
            "tz_id": 1,
            "alternate_daylight_code": "IST",
            "zone": "Asia/Kolkata",
            "country_id": 0
          })
          this.timezoneList$.next(timezones);
          this._local.customSetItem('engagement_allowed_role_ids', response.engagement_allowed_role_ids);
          this._local.customSetItem('timezones', timezones);
          this._local.customSetItem('twillio', response.twilio);
          this._local.customSetItem('email', response.email);
          this._local.customSetItem('cc_email', response.cc_email);
          this.stripeKey$.next(response.stripe_pk);
          this.industryList$.next(response.industries);
          this.menu$.next(response.menu);

          const admin_array = this.normalizeAdminArray(response?.admin_array);

          this.admin_array.set(admin_array);
          console.log(admin_array)
          this._local.customSetItem('admin_array', admin_array);
          // console.log(this._local.customGetItem('timezone'));
          // if (this._local.customGetItem('timezone_val')) {
          //   const timeZ = response.timezones.find((tz: any) => tz.val == this._local.customGetItem('timezone_val'));
          //   this.timezone$.next(timeZ['val']);
          //   this.timezoneName$.next(timeZ['name']);
          //   this.zone$.next(timeZ['zone']);
          // } else {
          //   if (response.timezones && response.timezones.length) {
          //     this.timezone$.next(response.timezones[0].val);
          //     this.timezoneName$.next(response.timezones[0].name);
          //     this.zone$.next(response.timezones[0].zone);
          //     this.government_docs$.next(response.government_docs);
          //     this._local.customSetItem('timezone_val', response.timezones[0].val)
          //   }
          // }

          if (this._local.customGetItem('country_id')) {
            const country = countryData.find((country: any) => country.country_id == this._local.customGetItem('country_id'));
            this.selected_country$.next(country);
            this.currencySymbol$.next(country?.display_logo || '$');
            this.setCountryContext(country);
          } else if (countryData.length) {
            const country = countryData[0];
            this.selected_country$.next(country);
            this.currencySymbol$.next(country.display_logo || '$');
            this.setCountryContext(country);
          }
        }
      })
      if (this._local.customGetItem('token')){
        this.fetchAdminList();
        this.getAdminName();
      }


      this.role = this._local.customGetItem('admin_profile') ? (this._local.customGetItem('admin_profile').role_id) : 0;

  }

  fetchAdminList() {
    let data = {
      limit: -1
    };
    this._api.api(data, 'user/fetch_admin_list', 'get')
      .subscribe((data: any) => {
        if (data && data.data && data.data.length) {
          this._socket.connect();
          this.global_admin_list$.next(data.data);
          this._local.customSetItem('adminList', data.data);
        }
      });

  }
  getAdminName() {
  this._api.api([], 'finance/calling_admin_list', 'get')
    .subscribe((resp: any) => {
      if (resp?.admin_data) {
        const list = [{
          label: "All",
          value: '-1'
        }];
        resp.admin_data.map((a: any) => (
          list.push({
          label: a.admin_name,
          value: a.admin_id,
        })));
        this.admin_twilio_list = list;
        this._local.customSetItem('admin_twilio_list', list);
      }
    });
}

  getNameFromArray(array: Array<[]>, id: number, key_id: string, return_key: string) {
    let name: any = array.find((obj: any) => {
      return obj[key_id] == id;
    });
    return name[return_key];
  }

  copyToClipboard(text: string) {
    // Create a temporary text area element
    let returnData;
    const textarea = document.createElement('textarea');
    textarea.value = text;
    document.body.appendChild(textarea);
    try {
      // Select and copy the text using the Clipboard API
      textarea.select();
      document.execCommand('copy');
      returnData = true;
    } catch (err) {
      console.error('Unable to copy to clipboard:', err);
      returnData = err;
    } finally {
      // Clean up by removing the temporary element
      document.body.removeChild(textarea);
    }
    return { textCopied: returnData };
  }

  checkProfile() {
    if (this._local.customGetItem('reset_password_token')) {
      this._router.navigate(['new-password']);
      return;
    }
    // return true;
  }

  getTimezoneCountry(): Observable<any> {
    return combineLatest([
      this.timezoneList$.asObservable(),
      this.country_data$.asObservable(),
    ]).pipe(
      // Ensure it only emits when values change to avoid multiple calls
      distinctUntilChanged(
        (prev, curr) => JSON.stringify(prev) === JSON.stringify(curr)
      )
    );
  }

  serverDate(date: any) {
    //convert MM-dd-yyyy to yyyy-MM-dd
    if (date == null) return date;
    var new_date = date.split('-');
    return new_date[2] + '-' + new_date[0] + '-' + new_date[1];
  }

  getUTCDate(date: string) {
    if (date == null) return '';
    var local = '';
    var t = date.split('T');
    if (t[1] == '') {
      return date;
    }
    if (date.indexOf('T') < 0) return date;
    var aD = t[0].split('-');
    local = '' + aD[1] + '-' + aD[2] + '-' + aD[0];
    return local;
  }

  schedulerUpdate(): Subject<MessageEvent> {
    const observable = new Observable(ob => {
      // this.socket.on('scheduler_update', (data: any) => {
      //   ob.next(data);
      // });
    });
    const observer = {
      next: (data: any) => {
        data['timezone'] = this._local.customGetItem('timezone');
        // this.socket.emit('auth', data);
      },
    };
    return Subject.create(observer, observable);
  }
  getFormattedDate(dateStr: string): string {
    const d = new Date(dateStr);
    const mm = String(d.getUTCMonth() + 1).padStart(2, '0');
    const dd = String(d.getUTCDate()).padStart(2, '0');
    const yyyy = d.getUTCFullYear();
    return `${mm}/${dd}/${yyyy}`;
  }

  setCountryContext(country: any): void {
    if (country?.country_id == null) {
      return;
    }

    const countries = this.country_data$.getValue() || [];
    const match = countries.find(
      (item: any) => String(item.country_id) === String(country.country_id)
    ) || country;

    this._local.customSetItem('country_id', match.country_id);

    const cocuId = this.getCocuIdForCountry(match);
    if (cocuId != null) {
      this._local.customSetItem('cocu_id', cocuId);
    }
  }

  getCocuIdForCountry(country: any): number | null {
    if (!country) {
      return null;
    }

    if (country.cocu_id != null && country.cocu_id !== '') {
      return Number(country.cocu_id);
    }

    const currencies = this.currency_data$.getValue() || [];
    const currency = currencies.find((item: any) =>
      (country.currency_id != null && String(item.currency_id) === String(country.currency_id)) ||
      (country.country_id != null && String(item.country_id) === String(country.country_id))
    );
    if (currency?.cocu_id != null) {
      return Number(currency.cocu_id);
    }

    if (Array.isArray(country.currency) && country.currency[0]?.cocu_id != null) {
      return Number(country.currency[0].cocu_id);
    }

    return null;
  }

}